module.exports = __webpack_public_path__ + "fonts/DINNextLTW23-Black.a8fb9227.woff";